import useSWR from 'swr';
import { useState } from 'react';
import { BonfireAPI, ApiType } from '../../models/BonfireApi';
import { AxiosError } from 'axios';
import { GET_TRANSLATIONS_SUMMARY } from '../../models/translations/urls';
import TranslationSummaryModel from '../../models/translations/translationsSummary';

const fetcher = async (url: string): Promise<TranslationSummaryModel[]> => {
	const api = new BonfireAPI(ApiType.QaApi);
	const params: any = {};
	url.split('?')[1]
		.split('&')
		.map(param => {
			const paramParts = param.split('=');
			params[paramParts[0]] = paramParts[1];
		});
	const translations: TranslationSummaryModel[] = (await api.requestArray(
		GET_TRANSLATIONS_SUMMARY,
		TranslationSummaryModel,
		{ query: params },
	)) as TranslationSummaryModel[];

	if (translations instanceof AxiosError) {
		throw translations;
	}

	return translations;
};

export default function useTranslation(
	category: string,
	startDate?: Date | null,
	endDate?: Date | null,
) {
	const [offset, setOffset] = useState(0);
	const pageSize = 20;

	let url = `/qa/listSummary?category=${category}`;
	if (startDate) {
		url += '&from=' + encodeURIComponent(startDate.toISOString());
	}
	if (endDate) {
		url += '&to=' + encodeURIComponent(endDate.toISOString());
	}

	const { data, isLoading, error, mutate } = useSWR(url, fetcher);

	const moveNext = () => {
		setOffset(offset + pageSize);
	};

	const movePrev = () => {
		let newOffset = offset - pageSize;
		if (newOffset < 0) {
			newOffset = 0;
		}
		setOffset(newOffset);
	};

	return {
		translationsSummary: data,
		translationsSummaryLoading: isLoading,
		translationsSummaryError: error,
		mutateTranslationsSummary: mutate,
		moveNext,
		movePrev,
		offset,
		pageSize,
	};
}
